import React,{Component} from 'react'

import {
  Chip,
} from 'material-ui'

import Fade from 'material-ui/transitions/Fade'

const style = {
  skillChip:{
    margin:'3px 5px'
  }
}

export default class SkillsChips extends Component {
  render(){
    return Object.keys(this.props.skills).map(sid=>this.props.skills[sid]).map(skill=> <Fade key={skill.sid} in={true}><Chip style={style.skillChip} className='skillChip' label={skill.name_display} /></Fade>)
  }
}



// WEBPACK FOOTER //
// ./src/components/SkillsChips.js